import { render, staticRenderFns } from "./ModalAcel.vue?vue&type=template&id=56c39113"
import script from "./ModalAcel.vue?vue&type=script&lang=js"
export * from "./ModalAcel.vue?vue&type=script&lang=js"
import style0 from "./ModalAcel.vue?vue&type=style&index=0&id=56c39113&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports